/* Elunor theme — behaviour
   AJAX cart (Shopify /cart/*.js), drawer, rail, filters, hotspots, motion.
   Everything is delegated so Theme Editor section reloads keep working. */
(function () {
  'use strict';

  var CFG = window.ELUNOR || {};
  var ROUTES = CFG.routes || { cartAdd: '/cart/add.js', cart: '/cart.js', cartChange: '/cart/change.js', cartPage: '/cart', shopAll: '/collections/all' };
  var FREE_SHIP = Number(CFG.freeShip || 9900);
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var n = Number(cents) / 100;
    function num(v, dec, thou, decsep) {
      var parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decsep);
    }
    var out = fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, num(n, 0, '.', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, num(n, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, num(n, 0, ',', '.'))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, num(n, 2, "'", '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, num(n, 2, ',', '.'));
    return out.replace(/<[^>]+>/g, '');
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-el-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('el-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('el-show'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  var lastFocus = null;
  function drawer() { return $('[data-el-cart]'); }
  function backdrop() { return $('[data-el-cart-backdrop]'); }

  function openCart() {
    var d = drawer(), b = backdrop();
    if (!d) { window.location.href = ROUTES.cartPage; return; }
    lastFocus = document.activeElement;
    if (b) b.hidden = false;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('el-open'); if (b) b.classList.add('el-open'); });
    document.body.style.overflow = 'hidden';
    var c = $('[data-el-cart-close]', d); if (c) c.focus();
  }
  function closeCart() {
    var d = drawer(), b = backdrop();
    if (!d || d.hidden) return;
    d.classList.remove('el-open'); if (b) b.classList.remove('el-open');
    document.body.style.overflow = '';
    setTimeout(function () { d.hidden = true; if (b) b.hidden = true; }, reduceMotion ? 0 : 500);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart(cart) {
    var items = $('[data-el-cart-items]');
    var foot = $('[data-el-cart-foot]');
    $$('[data-el-count]').forEach(function (el) {
      if (el.hasAttribute('data-el-count') && !el.getAttribute('data-el-count')) el.textContent = cart.item_count;
    });
    var lbl = $('[data-el-cart-count-label]');
    if (lbl) lbl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<div class="el-cart-empty"><p>Your bag is empty. Start with a bed, a crate, or something for the long walk.</p><a class="el-btn el-btn-ink el-btn-sm" href="' + esc(ROUTES.shopAll) + '" data-el-cart-close><span>Shop all</span></a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_168x168$1$2') : '';
      return '<div class="el-cart-item" data-key="' + esc(it.key) + '">' +
        (img ? '<a href="' + esc(it.url) + '"><img src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy"></a>' : '') +
        '<div><div class="el-ci-name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="el-ci-var">' + esc(it.variant_title) + '</div>' : '') +
        '<div class="el-ci-row"><div class="el-qty" aria-label="Quantity"><button type="button" data-el-qty="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-el-qty="1" aria-label="Increase">+</button></div>' +
        '<span class="el-ci-price">' + money(it.final_line_price) + '</span></div>' +
        '<button type="button" class="el-ci-remove" data-el-remove>Remove</button></div></div>';
    }).join('');
    var sub = $('[data-el-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    var msg = $('[data-el-ship-msg]');
    var bar = $('[data-el-ship-bar]');
    if (msg) msg.textContent = cart.total_price >= FREE_SHIP ? 'You have unlocked free US shipping.' : money(FREE_SHIP - cart.total_price) + ' away from free US shipping.';
    if (bar) bar.style.width = Math.min(100, Math.round(cart.total_price / FREE_SHIP * 100)) + '%';
  }

  function fetchCart() {
    return fetch(ROUTES.cart, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function bumpCount() {
    var c = $('[data-el-count=""]');
    if (!c) return;
    c.classList.remove('el-bump'); void c.offsetWidth; c.classList.add('el-bump');
  }

  function addItem(id, qty, fromImg, label) {
    return fetch(ROUTES.cartAdd, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || res.body.message || 'Could not add this item.'); return null; }
        return fetchCart().then(function (cart) {
          renderCart(cart);
          bumpCount();
          if (fromImg && !reduceMotion) fly(fromImg);
          toast('Added ' + (label || res.body.items && res.body.items[0] && res.body.items[0].product_title || 'item') + ' to your bag.');
          openCart();
          return cart;
        });
      }).catch(function () { toast('Network hiccup. Please try again.'); });
  }

  function changeItem(key, qty) {
    return fetch(ROUTES.cartChange, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.items) renderCart(cart); else { toast(cart.description || 'Could not update.'); return fetchCart().then(renderCart); }
    });
  }

  function fly(img) {
    var target = $('[data-el-count=""]');
    if (!target || !img.getBoundingClientRect) return;
    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width) return;
    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.className = 'el-fly';
    ghost.alt = '';
    ghost.style.left = (from.left + from.width / 2 - 28) + 'px';
    ghost.style.top = (from.top + from.height / 2 - 28) + 'px';
    document.body.appendChild(ghost);
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 80) + 'px) scale(.7)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.4 }
    ], { duration: 750, easing: 'cubic-bezier(.22,1,.36,1)' });
    anim.onfinish = function () { ghost.remove(); };
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-el-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-el-cart-close]')) { e.preventDefault(); closeCart(); return; }
    if (t.closest('[data-el-cart-backdrop]')) { closeCart(); return; }

    var q = t.closest('[data-el-qty]');
    if (q && q.closest('[data-el-cart]')) {
      var row = q.closest('.el-cart-item');
      var cur = Number(($('.el-qty span', row) || {}).textContent || 1);
      changeItem(row.getAttribute('data-key'), Math.max(0, cur + Number(q.getAttribute('data-el-qty'))));
      return;
    }
    var rm = t.closest('[data-el-remove]');
    if (rm) { changeItem(rm.closest('.el-cart-item').getAttribute('data-key'), 0); return; }

    var pq = t.closest('[data-el-pdp-qty]');
    if (pq) {
      var inp = $('[data-el-pdp-qty-input]', pq.closest('form'));
      if (inp) inp.value = Math.max(1, Number(inp.value || 1) + Number(pq.getAttribute('data-el-pdp-qty')));
      return;
    }

    var menuBtn = t.closest('[data-el-menu-btn]');
    if (menuBtn) {
      var menu = $('[data-el-mobile-menu]');
      var open = !menu.classList.contains('el-open');
      menu.classList.toggle('el-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      return;
    }
    if (t.closest('[data-el-mobile-menu] a')) closeMenu();

    var prev = t.closest('[data-el-rail-prev]'), next = t.closest('[data-el-rail-next]');
    if (prev || next) {
      var sec = (prev || next).closest('section');
      var rail = $('[data-el-rail]', sec);
      if (rail) {
        var card = rail.querySelector('.el-card');
        var step = (card ? card.getBoundingClientRect().width + 16 : 320) * 2;
        rail.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
      }
      return;
    }

    var chip = t.closest('[data-el-filter]');
    if (chip) { applyFilter(chip); return; }

    var hs = t.closest('[data-el-hotspot]');
    if (hs) { hs.classList.contains('el-is-active') ? closeHotspots() : openHotspot(hs); return; }
    if (t.closest('[data-el-hotspot-close]')) { closeHotspots(); return; }
    if (!t.closest('[data-el-hotspot-card]') && $('.el-hotspot.el-is-active')) closeHotspots();

    var thumb = t.closest('[data-el-thumb]');
    if (thumb) {
      var main = $('.el-pdp-main img');
      if (main) { main.src = thumb.getAttribute('data-el-thumb'); main.removeAttribute('srcset'); }
      $$('.el-pdp-thumb').forEach(function (b) { b.classList.toggle('el-is-active', b === thumb); });
    }
  });

  function closeMenu() {
    var menu = $('[data-el-mobile-menu]'), btn = $('[data-el-menu-btn]');
    if (menu) menu.classList.remove('el-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); closeHotspots(); } });

  /* ---------- add-to-cart forms (cards, hotspots, product page) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-el-add-form], [data-el-product-form]')) return;
    e.preventDefault();
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[type="submit"]');
    var card = form.closest('.el-card, .el-hotspot-card, [data-el-product]');
    var img = card ? card.querySelector('img') : null;
    var name = card ? (card.querySelector('.el-card-name, .el-hc-name, h1') || {}).textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('el-busy'); }
    addItem(idEl.value, Number(qtyEl ? qtyEl.value : 1), img, (name || '').trim()).then(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('el-busy'); }
    });
  });

  /* ---------- variant selects ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-el-variant-select]');
    if (sel) {
      var card = sel.closest('.el-card');
      var opt = sel.selectedOptions[0];
      var input = $('[data-el-variant-input]', card);
      if (input) input.value = sel.value;
      var price = $('[data-el-price]', card);
      if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      var btn = $('[data-el-add-form] button', card);
      if (btn) { var soldOut = opt.disabled || opt.getAttribute('data-available') === 'false'; btn.disabled = soldOut; btn.querySelector('span').textContent = soldOut ? 'Sold out' : 'Add to bag'; }
      return;
    }
    var psel = e.target.closest('[data-el-pdp-select]');
    if (psel) updatePdp(psel);
  });

  function updatePdp(sel) {
    var root = sel.closest('[data-el-product]');
    var data = $('[data-el-variants]', root);
    if (!data) return;
    var variants; try { variants = JSON.parse(data.textContent); } catch (err) { return; }
    var v = variants.filter(function (x) { return String(x.id) === String(sel.value); })[0];
    if (!v) return;
    var price = $('[data-el-pdp-price]', root); if (price) price.textContent = money(v.price);
    var cmp = $('[data-el-pdp-compare]', root);
    if (cmp) { if (v.compare_at_price && v.compare_at_price > v.price) { cmp.textContent = money(v.compare_at_price); cmp.hidden = false; } else cmp.hidden = true; }
    var add = $('[data-el-pdp-add]', root);
    if (add) { add.disabled = !v.available; add.querySelector('span').textContent = v.available ? 'Add to bag' : 'Sold out'; }
    var stock = $('[data-el-pdp-stock]', root);
    var low = Number(CFG.lowStock || 15);
    if (stock) stock.textContent = (v.available && v.inventory_management && v.inventory_quantity <= low && v.inventory_quantity > 0) ? 'Only ' + v.inventory_quantity + ' left.' : '';
    if (v.featured_image && v.featured_image.src) {
      var main = $('.el-pdp-main img', root);
      if (main) { main.src = v.featured_image.src; main.removeAttribute('srcset'); }
    }
    if (history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
  }

  /* ---------- shop filters (client-side, by collection handles) ---------- */
  function applyFilter(chip) {
    var sec = chip.closest('section');
    var handle = chip.getAttribute('data-el-filter');
    var cards = $$('[data-el-card]', $('[data-el-grid]', sec));
    var n = 0;
    cards.forEach(function (c) {
      var show = handle === 'all' || (' ' + (c.getAttribute('data-collections') || '') + ' ').indexOf(' ' + handle + ' ') > -1;
      c.hidden = !show;
      if (show) { n++; c.style.setProperty('--i', n % 12); c.classList.remove('el-in'); void c.offsetWidth; c.classList.add('el-in'); }
    });
    $$('[data-el-filter]', sec).forEach(function (c) { var on = c === chip; c.classList.toggle('el-is-active', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); });
    var count = $('[data-el-shop-count]', sec); if (count) count.textContent = n + (n === 1 ? ' piece' : ' pieces');
    var empty = $('[data-el-grid-empty]', sec); if (empty) empty.hidden = n > 0;
  }

  /* ---------- hotspots ---------- */
  function closeHotspots() {
    $$('[data-el-hotspot-card]').forEach(function (c) { c.hidden = true; });
    $$('[data-el-hotspot]').forEach(function (h) { h.classList.remove('el-is-active'); h.setAttribute('aria-expanded', 'false'); });
  }
  function openHotspot(btn) {
    closeHotspots();
    var id = btn.getAttribute('data-el-hotspot');
    var stage = btn.closest('[data-el-room]');
    var card = $('[data-el-hotspot-card="' + id + '"]', stage);
    if (!card) return;
    btn.classList.add('el-is-active'); btn.setAttribute('aria-expanded', 'true');
    card.hidden = false;
    var sr = stage.getBoundingClientRect(), br = btn.getBoundingClientRect();
    var cw = Math.min(280, sr.width - 32);
    var left = br.left - sr.left + 30;
    if (left + cw > sr.width - 16) left = br.left - sr.left - cw - 30;
    if (left < 16) left = 16;
    var top = br.top - sr.top - 40;
    var ch = card.offsetHeight || 110;
    if (top + ch > sr.height - 16) top = sr.height - ch - 16;
    if (top < 16) top = 16;
    card.style.left = left + 'px'; card.style.top = top + 'px';
  }

  /* ---------- rail drag ---------- */
  function initRails() {
    $$('[data-el-rail]').forEach(function (rail) {
      if (rail.__el) return; rail.__el = true;
      var drag = null;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; drag = { x: e.clientX, left: rail.scrollLeft, moved: false }; rail.setPointerCapture(e.pointerId); });
      rail.addEventListener('pointermove', function (e) {
        if (!drag) return; var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 4) { drag.moved = true; rail.classList.add('el-dragging'); }
        if (drag.moved) rail.scrollLeft = drag.left - dx;
      });
      var end = function () { if (!drag) return; drag = null; setTimeout(function () { rail.classList.remove('el-dragging'); }, 30); };
      rail.addEventListener('pointerup', end); rail.addEventListener('pointercancel', end); rail.addEventListener('pointerleave', end);
      rail.addEventListener('click', function (e) { if (rail.classList.contains('el-dragging')) { e.preventDefault(); e.stopPropagation(); } }, true);
      var wrap = rail.closest('[data-el-rail-wrap]'), hint = wrap && $('[data-el-drag-hint]', wrap);
      if (wrap && hint) wrap.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return; var r = wrap.getBoundingClientRect();
        hint.style.left = (e.clientX - r.left) + 'px'; hint.style.top = (e.clientY - r.top) + 'px';
      });
    });
  }

  /* ---------- motion ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('el-in'); io.unobserve(en.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  var counterIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target; counterIO.unobserve(el);
      var target = Number(el.getAttribute('data-el-count'));
      if (reduceMotion) { el.textContent = target; return; }
      var start = performance.now(), dur = 1200;
      var tick = function (t) { var k = Math.min(1, (t - start) / dur); var e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(target * e); if (k < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });

  function initMotion() {
    $$('.el-reveal:not(.el-in)').forEach(function (el) { io.observe(el); });
    $$('.el-mask-reveal:not(.el-in)').forEach(function (el) {
      if (el.__el) return; el.__el = true;
      var mio = new IntersectionObserver(function (entries) { if (entries.some(function (en) { return en.isIntersecting; })) { el.classList.add('el-in'); mio.disconnect(); } }, { threshold: 0.15 });
      mio.observe(el.parentElement);
    });
    $$('[data-el-split]:not(.el-in)').forEach(function (el) { requestAnimationFrame(function () { setTimeout(function () { el.classList.add('el-in'); }, 80); }); });
    $$('[data-el-count]').forEach(function (el) { if (el.getAttribute('data-el-count') && !el.__el) { el.__el = true; counterIO.observe(el); } });
    initRails();
    // cards visible on load
    $$('.el-card:not(.el-in)').forEach(function (c) { io.observe(c); });
  }

  function updateTheme() {
    var mid = window.innerHeight * 0.5;
    var anyDark = $$('[data-el-dark]').some(function (s) { var r = s.getBoundingClientRect(); return r.top < mid && r.bottom > mid; });
    document.body.classList.toggle('el-theme-dark', anyDark);
  }
  function onScroll() {
    var bar = $('[data-el-progress]');
    if (bar) { var h = document.documentElement; bar.style.transform = 'scaleX(' + (h.scrollTop / (h.scrollHeight - h.clientHeight || 1)) + ')'; }
    updateTheme();
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  function init() { initMotion(); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme Editor: re-init when sections are (re)loaded
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('shopify:block:select', function (e) {
    var hs = e.target && e.target.matches && e.target.matches('[data-el-hotspot]') ? e.target : null;
    if (hs) openHotspot(hs);
  });
})();
